import { Component, Input, OnDestroy, OnInit, Inject, Optional } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from './../../Services/common.service';
import { CartObject } from 'src/app/Services/cart-object';
import { CardObject } from 'src/app/Services/card-object';
import moment from 'moment';
import { CommonServices } from 'src/app/Common/CommonServices';
import { CardDetail, Cart, CartClient, User , PaymentClient,OrderDTO , OrderItemDTO, API_BASE_URL} from 'src/app/Services/WOWApi.Service';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http'; 
import { Router } from '@angular/router';
import { openConfirmDialog } from 'src/app/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-veem-payment',
    templateUrl: './veem-payment.component.html',
    styleUrls: ['./veem-payment.component.css'],
    standalone: false
})
export class VeemPaymentComponent implements OnInit, OnDestroy {
  loggedUser: User;
  showSpinner: any = {};
  savedCards: CardDetail[] = [];
  savedCardCvv: string = '';
  selectedSavedActiveCard: number;
  cartDetails: CartObject[] = [];
  subscription: Subscription;
  isMobileView = false;
  card: CardObject = new CardObject();
  OrderDTO: OrderDTO = new OrderDTO();
  Months: {month: number, name: string}[] = [
    {month: 1, name: 'January'},
    {month: 2, name: 'February'},
    {month: 3, name: 'March'},
    {month: 4, name: 'April'},
    {month: 5, name: 'May'},
    {month: 6, name: 'June'},
    {month: 7, name: 'July'},
    {month: 8, name: 'August'},
    {month: 9, name: 'September'},
    {month: 10, name: 'October'},
    {month: 11, name: 'November'},
    {month: 12, name: 'December'},
  ]
  Years: number[] = [];
  userCart: Cart;
  cartRemainingTime = '';
  walletBalance: number = 0;
  useWallet: boolean = false;
  walletAmountToUse: number = 0;
  isLoadingWallet: boolean = false;
  private baseUrl: string;

  constructor(
    private commonService: CommonService,
    private commonServices: CommonServices,
    private cartClient: CartClient,
    private paymentClient: PaymentClient,
    private customServices: CustomServiceService,
    private router: Router,
    private dialog: MatDialog,
    private http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  ngOnInit(): void {
    // setTimeout(() => {
    //   this.cardNumberControl.valueChanges.subscribe(value => {
    //     this.addHypensToCardNumberControl(value);
    //   });
    // }, 100)
    this.loggedUser = this.customServices.GetLoggedInUser();
    if (this.loggedUser !== undefined && this.loggedUser !== null) {
      this.getSavedCardDetails(this.loggedUser.id);
      this.loadWalletBalance();
    }
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.subscription = this.commonService.cartDetails.subscribe(details => this.cartDetails = details);
    this.subscription = this.commonService.userCart.subscribe(cart => {
      this.userCart = cart;
      if (this.userCart.cartDetails.length === 0) {
        this.router.navigateByUrl('/Webinar-rooms');
      }
    });
    this.subscription = this.commonService.cartExpireRemainingTime.subscribe(remainingTime => this.cartRemainingTime = remainingTime);
    const curYear = moment(new Date()).year();
    this.Years.push(curYear);
    for(let i = 0; i < 25; i++) {
      this.Years.push(Number(curYear) + i + 1);
    }
    this.card.cardExpirationMonth = 0;
    this.card.cardExpirationYear = 0;
    // new Veem.WebSDK({
    //   name: 'authorization',
    //   clientId: '<application_client_id>',
    //   target: '#container',
    //   onComplete: ({ referenceId }) => console.log('Account referenceId:', referenceId),
    // })

    // new Veem.WebSDK({
    //   name: 'sendPayment',
    //   clientId: '<application_client_id>',
    //   target: '#container',
    //   onComplete: ({ id }) => console.log('Payment created with ID:', id), 
    //   preset: {
    //     accountId: 12345,
    //     payerAmount: 500,
    //     payerCurrencyCode: 'USD',
    //   },
    // })
  }

  cartTotalCost() {
    let cost = 0;
    this.cartDetails.map(x => {
      cost += x.pricePerSeat * x.seats.length;
    });
    return Number(cost.toFixed(2));
  }

  cartTaxes(): number {
    return 0
  }

  cartShippingCharges(): number {
    return 0;
  }

  loadWalletBalance(): void {
    if (!this.loggedUser || !this.loggedUser.id) {
      return;
    }

    this.isLoadingWallet = true;
    const apiUrl = `${this.baseUrl}/api/Wallet/GetAvailableBalance/${this.loggedUser.id}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    this.http.get<number>(apiUrl, { headers }).subscribe(
      (balance: number) => {
        this.walletBalance = balance || 0;
        this.updateWalletAmountToUse();
        this.isLoadingWallet = false;
      },
      (error) => {
        // If wallet doesn't exist, balance is 0
        this.walletBalance = 0;
        this.isLoadingWallet = false;
        // Don't show error - wallet might not exist yet
      }
    );
  }

  onUseWalletChange(): void {
    this.updateWalletAmountToUse();
  }

  updateWalletAmountToUse(): void {
    if (this.useWallet && this.walletBalance > 0) {
      const totalCost = this.cartTotalCost();
      this.walletAmountToUse = Math.min(this.walletBalance, totalCost);
    } else {
      this.walletAmountToUse = 0;
    }
  }

  getRemainingAmount(): number {
    if (this.useWallet && this.walletAmountToUse > 0) {
      return Number(Math.max(0, this.cartTotalCost() - this.walletAmountToUse).toFixed(2));
    }
    return this.cartTotalCost();
  }

  onCvvEntry(type: string) {
    if (type === 'new') {
      const element = document.getElementById('cvvNumber') as HTMLInputElement;
      const validValues = element.value.match(/^[0-9]*$/);
      const value = JSON.parse(JSON.stringify(element.value));
      const len = element.value.length;
      if (validValues === null) {
        element.value = value.slice(0, len-1);
        this.commonServices.showMessage('Error', 'Only numbers allowed');
      }
      if (value.length > 4) {
        element.value = value.slice(0, len-1);
      }
    }
    
    if (type == 'savedCard') {
      const element = document.getElementById('cvvNumberSavedCard') as HTMLInputElement;
      const validValues = element.value.match(/^[0-9]*$/);
      const value = JSON.parse(JSON.stringify(element.value));
      const len = element.value.length;
      if (validValues === null) {
        element.value = value.slice(0, len-1);
        this.commonServices.showMessage('Error', 'Only numbers allowed');
      }
      if (value.length > 4) {
        element.value = value.slice(0, len-1);
      } 
    }
  }

  onCreditCardNoEntry() {
    const element = document.getElementById('cardNumber') as HTMLInputElement;
    const validValues = element.value.match(/^[0-9-]*$/);
    const value = JSON.parse(JSON.stringify(element.value));
   
    const len = element.value.length;
    if (validValues === null) {
      element.value = value.slice(0, len-1);
      this.commonServices.showMessage('Error', 'Only numbers allowed');
    }
    if (value.length > 19) {
      element.value = value.slice(0, 19);
    }
    if(element.value.length === 4) {
      element.value = value + '-';
    }
    if(element.value.length === 9) {
      element.value = value + '-';
    }
    if(element.value.length === 14) {
      element.value = value + '-';
    }
    for (let i = 0; i < value.length; i++) {
      // hypen locations as per logic should be 4, 9, 14 only
      if(value[i] === '-' && i !== 4 && i !== 9 && i !== 14) {
        element.value = value.slice(0, len-1);
        this.commonServices.showMessage('Error', 'Only numbers allowed');
      }
    }
  }

  onCardExpirtyEntry() {
    const element = document.getElementById('cardExpiry') as HTMLInputElement;
    const value = JSON.parse(JSON.stringify(element.value));
    if (value.length > 5) {
      element.value = value.slice(0, 5);
    }
    if(element.value.length === 2) {
      element.value = value + '/';
    }
  }

  onMakePayment() {
    // Check if wallet covers full payment - skip card validation if so
    const remainingAmount = this.getRemainingAmount();
    const isWalletOnlyPayment = this.useWallet && remainingAmount === 0;

    // Only validate card details if there's a remaining amount to pay
    if (!isWalletOnlyPayment) {
      const cardValue = document.getElementById('cardNumber') as HTMLInputElement;
      this.card.cardNumber = cardValue.value;
      if (this.card.cardNumber === undefined) {
        this.commonServices.showMessage('Error', 'Please provide the card number.');
        return;
      }
      if (this.card.cardNumber.length < 19) {
        this.commonServices.showMessage('Error', 'Please provide the valid card number.');
        return;
      }
      if (this.card.cardNumber.length > 19)  {
        this.commonServices.showMessage('Error', 'Please provide valid 16 digit card number.');
        return;
      }

      if (this.card.cardExpirationMonth === undefined) {
        this.commonServices.showMessage('Error', 'Please provide card expiry month.');
        return;
      }
      if (this.card.cardExpirationMonth > 12 || this.card.cardExpirationMonth < 1) {
        this.commonServices.showMessage('Error', 'Please provide valid card expiry month.');
        return;
      }

      if (this.card.cardExpirationYear === undefined) {
        this.commonServices.showMessage('Error', 'Please provide card expiry year.');
        return;
      }
      if (this.card.cardExpirationYear < moment(new Date()).year()) {
        this.commonServices.showMessage('Error', 'Please provide valid card expiry year.');
        return;
      }

      if (this.card.cardCvv === undefined) {
        this.commonServices.showMessage('Error', 'Please provide CVV number.');
        return;
      }
      if (this.card.cardCvv.length < 3 || this.card.cardCvv.length > 4) {
        this.commonServices.showMessage('Error', 'Please provide valid cvv number.');
        return;
      }

      if (this.card.cardOwnerName === undefined) {
        this.commonServices.showMessage('Error', 'Please provide card holder name.');
        return;
      }
    }
    
    if (this.card.isTermsConditionAccepted === false) {
      this.commonServices.showMessage('Error', 'Please accept Terms & Conditions to proceed.');
      return;
    }
    if (this.userCart.cartDetails.length === 0) {
      this.commonServices.showMessage('Error', `Please check your card, there is no item in cart.`);
      return;
    }
    
    const totalAmount = this.cartTotalCost();
    const walletPayment = this.useWallet ? this.walletAmountToUse : 0;
    
    let confirmMessage = '';
    if (isWalletOnlyPayment) {
      confirmMessage = `Are you sure you want to pay ${this.convertToNumberUsEn(totalAmount)} using your Lucky Bucks wallet?`;
    } else if (this.useWallet && remainingAmount > 0) {
      confirmMessage = `Are you sure you want to pay ${this.convertToNumberUsEn(walletPayment)} from wallet and ${this.convertToNumberUsEn(remainingAmount)} via card (Total: ${this.convertToNumberUsEn(totalAmount)})?`;
    } else {
      confirmMessage = `Are you sure you want to make payment of ${this.convertToNumberUsEn(totalAmount)}?`;
    }

    openConfirmDialog(this.dialog, {
        message: confirmMessage,
        buttonText: {
          ok: 'Yes, Make Payment',
          cancel: 'No, Cancel'
        }
    }).afterClosed().subscribe(res => {
      if (res === true) {
        // Only set card details if not wallet-only payment
        if (!isWalletOnlyPayment) {
          this.OrderDTO.isSaveCardDetails = this.card.isSaveCardDetails;
          this.OrderDTO.cardNumber = this.card.cardNumber;
          this.OrderDTO.cardExpiryMonth = this.card.cardExpirationMonth.toString();
          this.OrderDTO.cardExpiryYear = this.card.cardExpirationYear.toString();
          this.OrderDTO.cardCvv = this.card.cardCvv;
          this.OrderDTO.cardHolderName = this.card.cardOwnerName;
        } else {
          // For wallet-only payment, set empty/default values
          this.OrderDTO.isSaveCardDetails = false;
          this.OrderDTO.cardNumber = '';
          this.OrderDTO.cardExpiryMonth = '';
          this.OrderDTO.cardExpiryYear = '';
          this.OrderDTO.cardCvv = '';
          this.OrderDTO.cardHolderName = '';
        }
        this.OrderDTO.userId = this.loggedUser.id;
        this.OrderDTO.useWallet = this.useWallet;
        this.OrderDTO.walletAmount = this.walletAmountToUse;

        const orderItems: OrderItemDTO[] = [];
        this.userCart.cartDetails.map(item => {
          const orderItem: OrderItemDTO = new OrderItemDTO();
          orderItem.webinarId = item.webinarId;
          orderItem.amount = item.webinar.pricePerSeat;
          orderItem.seatId = item.seatId;
          orderItem.currency = 'USD';
          orderItem.cartId = item.cartId;
          orderItems.push(orderItem);
        });
        this.OrderDTO.orderItems = orderItems;
        this.showSpinner.checkout = true;
        this.cartClient.cartCheckoutWithCardPayment(this.OrderDTO).subscribe(res => {
          if (res.isOrderPlaced) {
            this.commonServices.showMessage('Success', `Order placed successfully with orderID:: ${res.orderId}, please check details in Purchase History under MyAccount.`, 20, 'top');
            this.commonService.setCartDetails([]);
            this.commonService.setUserCart({cartDetails: []})
            this.commonService.setIsPageReload(true);
            this.router.navigateByUrl('/MyAccount/1');
          }
          if (!res.isOrderPlaced) {
            this.commonServices.showMessage('Error', `${res.message}`, 10);
          }
          this.showSpinner.checkout = false;
        }, (error: HttpErrorResponse) => {
          this.commonServices.showMessage('Error', `${error.error}`);
          this.showSpinner.checkout = false;
        });
      }
    });
  }

  checkCardFormValidation(): boolean {
    // If using wallet and it covers full amount, no card validation needed
    if (this.useWallet && this.getRemainingAmount() === 0) {
      return this.card.isTermsConditionAccepted === true;
    }

    // Otherwise, validate card details
    const cardValue = document.getElementById('cardNumber') as HTMLInputElement;
    this.card.cardNumber = cardValue.value;
    if (this.card.cardNumber === undefined) {
      return false;
    } else if (this.card.cardNumber.length < 19) {
      return false;
    } else if (this.card.cardNumber.length > 19)  {
      return false;
    } else if (this.card.cardExpirationMonth === undefined) {
      return false;
    } else if (this.card.cardExpirationMonth > 12 || this.card.cardExpirationMonth < 1) {
      return false;
    } else if (this.card.cardExpirationYear === undefined) {
      return false;
    } else if (this.card.cardExpirationYear < moment(new Date()).year()) {
      return false;
    } else if (this.card.cardCvv === undefined) {
      return false;
    } else if (this.card.cardCvv.length < 3 || this.card.cardCvv.length > 4) {
      return false;
    } else if (this.card.cardOwnerName === undefined) {
      return false;
    } else if (this.card.isTermsConditionAccepted === false) {
      return false;
    } else if (this.card.cardOwnerName === '' || this.card.cardOwnerName === null || this.card.cardOwnerName === undefined) {
      return false;
    } else {
      return true
    }
  }

  getSavedCardDetails(userId: number) {
    this.showSpinner.savedCards = true;
    this.paymentClient.getUserSavedCardDetails(userId).subscribe(res => {
      this.savedCards = res.filter(x => x.isActive === true);
      this.showSpinner.savedCards = false;
    }, (error: HttpErrorResponse) => {
      this.commonServices.showMessage('Error', `${error.error}`);
      this.showSpinner.savedCards = false;
    })
  }

  showLast4DigitsCardNumber(cardNo: string) {
    return this.cardLast4(cardNo);
  }

  cardLast4(cardNo: string): string {
    const digits = (cardNo || '').replace(/\D/g, '');
    if (digits.length >= 4) {
      return digits.slice(-4);
    }
    const parts = (cardNo || '').split('-');
    return parts.length > 1 ? parts[parts.length - 1] : '••••';
  }

  cardBrand(cardNo: string): string {
    const digits = (cardNo || '').replace(/\D/g, '');
    if (digits.startsWith('4')) {
      return 'Visa';
    }
    const prefix = Number(digits.slice(0, 4));
    if (digits.startsWith('5') || (prefix >= 2221 && prefix <= 2720)) {
      return 'Mastercard';
    }
    if (digits.startsWith('34') || digits.startsWith('37')) {
      return 'Amex';
    }
    if (digits.startsWith('6')) {
      return 'Discover';
    }
    return 'Card';
  }

  formatCardExpiry(month: string, year: string): string {
    if (!month || !year) {
      return '—';
    }
    const mm = String(month).padStart(2, '0');
    return `${mm}/${year}`;
  }

  onChangeSavedCard(cardId: number) {
    this.selectedSavedActiveCard = cardId;
    this.savedCardCvv = '';
  }

  onMakePaymentThroughSavedCard(card: CardDetail) {
    if (this.userCart.cartDetails.length === 0) {
      this.commonServices.showMessage('Error', `Please check your card, there is no item in cart.`);
      return;
    }
    
    const totalAmount = this.cartTotalCost();

    const walletPayment = this.useWallet ? this.walletAmountToUse : 0;
    const remainingAmount = this.getRemainingAmount();
    
    let confirmMessage = '';
    if (this.useWallet && remainingAmount === 0) {
      confirmMessage = `Are you sure you want to pay ${this.convertToNumberUsEn(totalAmount)} using your Lucky Bucks wallet?`;
    } else if (this.useWallet && remainingAmount > 0) {
      confirmMessage = `Are you sure you want to pay ${this.convertToNumberUsEn(walletPayment)} from wallet and ${this.convertToNumberUsEn(remainingAmount)} via saved card (Total: ${this.convertToNumberUsEn(totalAmount)})?`;
    } else {
      confirmMessage = `Are you sure you want to make payment of ${this.convertToNumberUsEn(totalAmount)}?`;
    }

    openConfirmDialog(this.dialog, {
        message: confirmMessage,
        buttonText: {
          ok: 'Yes, Make Payment',
          cancel: 'No, Cancel'
        }
    }).afterClosed().subscribe(res => {
      if (res === true) {
        this.OrderDTO.isSaveCardDetails = false;
        this.OrderDTO.cardNumber = card.cardNumber;
        this.OrderDTO.cardExpiryMonth = card.cardExpiryMonth;
        this.OrderDTO.cardExpiryYear = card.cardExpiryYear;
        this.OrderDTO.cardCvv = this.savedCardCvv;
        this.OrderDTO.cardHolderName = card.cardHolderName;
        this.OrderDTO.userId = this.loggedUser.id;
        this.OrderDTO.useWallet = this.useWallet;
        this.OrderDTO.walletAmount = this.walletAmountToUse;

        const orderItems: OrderItemDTO[] = [];
        this.userCart.cartDetails.map(item => {
          const orderItem: OrderItemDTO = new OrderItemDTO();
          orderItem.webinarId = item.webinarId;
          orderItem.amount = item.webinar.pricePerSeat;
          orderItem.seatId = item.seatId;
          orderItem.currency = 'USD';
          orderItem.cartId = item.cartId;
          orderItems.push(orderItem);
        });
        this.OrderDTO.orderItems = orderItems;
        this.showSpinner.checkout = true;
        this.cartClient.cartCheckoutWithCardPayment(this.OrderDTO).subscribe(res => {
          if (res.isOrderPlaced) {
            this.commonServices.showMessage('Success', `Order placed successfully with orderID:: ${res.orderId}, please check details in Purchase History under MyAccount.`, 20, 'top');
            this.commonService.setCartDetails([]);
            this.commonService.setUserCart({cartDetails: []})
            this.commonService.setIsPageReload(true);
            this.router.navigateByUrl('/MyAccount/1');
          }
          if (!res.isOrderPlaced) {
            this.commonServices.showMessage('Error', `${res.message}`, 10);
          }
          this.showSpinner.checkout = false;
        }, (error: HttpErrorResponse) => {
          this.commonServices.showMessage('Error', `${error.error}`);
          this.showSpinner.checkout = false;
        });
      }
    });
  }

  onDeleteSavedCardDetail(cardId: number) {
    this.showSpinner.cardDelete = true;
    this.paymentClient.deleteUserCardDetail(cardId).subscribe(res => {
      if (res === true) {
        const idx = this.savedCards.findIndex(x => x.id === cardId);
        this.savedCards.splice(idx, 1);
        this.commonServices.showMessage('Success', `Card details deleted successfully.`);
      }
      this.showSpinner.cardDelete = false;
    }, error => {
      this.commonServices.showMessage('Error', `${error.error}`);
      this.showSpinner.cardDelete = false;
    });
  }

  goToCart() {
    console.log('navigating to cart');
    this.router.navigateByUrl('/Cart');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
    this.addHypensToCardNumberControl(pastedText);
    // let formattedValue = '';
    // for (let i = 0; i < pastedText.length; i++) {
    //   if (formattedValue.length > 19) {
    //     console.log(formattedValue);
    //     this.commonServices.showMessage('error', 'Only 16 digits allowed, remaining digits truncated.', 5);
    //     break;
    //   }
    //   formattedValue += pastedText[i]; 
    //   // hypen locations as per logic should be 4, 9, 14 only
    //   if (formattedValue.length === 4 || formattedValue.length === 9 || formattedValue.length === 14) {
    //     formattedValue += '-';
    //   }
    // }
    // const element = document.getElementById('cardNumber') as HTMLInputElement;
    // this.card.cardNumber = formattedValue;
    // element.value = formattedValue;
  }

  addHypensToCardNumberControl(pastedText: string) {
    let convertedText = '';
    if (pastedText !== null) {
      const textArr = pastedText.split('');
      textArr.map((x, i)=> {
        if (convertedText.length <= 18) {
          convertedText += x;
          if (i === 3 || i === 7 || i === 11) {
            convertedText += '-';
          }
        }
      });
      this.card.cardNumber = convertedText;
    }
    // let formattedValue = '';
    // for (let i = 0; i < pastedText.length; i++) {
    //   if (formattedValue.length > 19) {
    //     this.commonServices.showMessage('error', 'Only 16 digits allowed, remaining digits have been trancated.', 5);
    //     return;
    //   }
    //   // if (formattedValue.length === 19) {
    //   //   break;
    //   // }
    //   formattedValue += pastedText[i]; 
    //   // hypen locations as per logic should be 4, 9, 14 only
    //   if (formattedValue.length === 4 || formattedValue.length === 9 || formattedValue.length === 14) {
    //     formattedValue += '-';
    //   }
    // }
    // const element = document.getElementById('cardNumber') as HTMLInputElement;
    
    // element.value = convertedText;
    
  }

  convertToNumberUsEn(amont: number): string {
    return amont.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }
}
